<template>
  <section>
    <transition name="fade">
      <div v-if="showScheduler" class="backdrop"></div>
    </transition>
    <div class="step-holder container">
      <div class="columns">
        <div class="column is-10 is-offset-1 stepbar-padding">
          <div class="lc-intro-block">
            <h3 class="intro">We have everything that we need to start your prototype and factory match making.</h3>
            <p>In order to kick start you should schedule an appointment with our digital supply chain consultant</p>
          </div>
          <div class="columns">
            <div class="column is-hidden-mobile">
              <div class="lc-product">
                <LCProductFrontBack :front="form.productThumbnail" :back="form.productThumbnailBack"/>
                <div class="product-title">{{form.productModel}}</div>
                <div class="factories-tip">+50 factories that could build this product</div>
              </div>
            </div>
            <div class="column is-8">
              <p class="hello">Hello</p>
              <p class="review">
                My name <span>{{form.name}}</span> with email <span>{{form.email}}</span> and I want to {{existingProductLabel}} a <span>{{form.productModel}}</span><br/>
                I have a budget between <span>{{form.retailCost}} USD$</span> and my target is <span>{{form.region}}</span>.
              </p>
              <p class="review">
                Regarding customization <span>{{form.comments}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition
      mode="out-in"
      enter-active-class="animate__animated animate__slideInRight"
      leave-active-class="animate__animated animate__slideOutRight"
    >
      <LeadFormSchedule
        v-if="showScheduler"
        class="calendly-component"
        :form="form"
        @scheduled="emitScheduled"
        @back="emitBack"
      />
    </transition>
  </section>
</template>

<script>
  import LeadFormSchedule from '@/components/leads/form/Schedule.vue'
  import LCProductFrontBack from '@/components/leads_catcher/LCProductFrontBack.vue'

  export default {
    name: 'Review',
    components: {
      LeadFormSchedule,
      LCProductFrontBack
    },
    props: {
      form: Object,
      showScheduler: Boolean
    },
    mounted() {
      this.emitValidate()
    },
    computed: {
      existingProductLabel() {
        return this.form.existingProduct ? 'scale' : 'create'
      }
    },
    methods: {
      validate() {
        return true
      },
      emitValidate() {
        this.$emit('validated', this.validate())
      },
      emitScheduled() {
        this.$emit('scheduled')
      },
      emitBack() {
        this.$emit('back')
      },
    }
  }
</script>

<style lang="scss" scoped>
  .lc-product {
    margin-top: -10px;
  }

  .product-title,
  .factories-tip {
    text-align: center;
    width: 100%;
  }

  .product-title {
    font-size: 20px;
    font-weight: bold;
    color: #FFD1AD;
    margin-top: 10px;
  }

  .factories-tip {
    font-size: 12px;
    color: rgba(255,255,255,0.8);
  }

  .backdrop {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 1000;
    background: rgba(0,0,0,0.2);
  }


  .hello,
  .review {
    font-weight: bold;
    font-size: 20px;
    margin-bottom: 30px;
  }

  .hello {
    color: rgba(255,255,255,0.6);
  }

  .review {
    span {
      color: #fff;
    }
  }
</style>
